<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFlag } from '@loadsmart/vue-feature-flags';

import Navbar from '@/components/Navbar.vue';
import RecaptchaAttribution from '@/components/RecaptchaAttribution.vue';

import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';

const checkoutFlow = useCheckoutFlow();
const { isLoading, fetchAndStoreWarehouseInfo } = useWarehouseInfo();
const { t } = useI18n();

const isWarehouseLoading = computed(() => isLoading.value);

// Mirrors Comet's isCometBffEnabled gate: reCAPTCHA only runs on the BFF paths, so with
// the flag off no token is requested and there is nothing to attribute. The badge itself
// is hidden either way (apps/juno/src/styles/main.scss).
const bffFlag = useFlag('enable-juno-bff');
const isBffEnabled = computed(() => Boolean(bffFlag.value?.enabled));

onMounted(async () => {
  await fetchAndStoreWarehouseInfo();
});
</script>

<template>
  <div
    class="page fill-height d-flex flex-column gap-6 pt-4"
    :class="checkoutFlow.step.value === CheckoutFlowStep.CheckoutCompletePage && 'bg-secondary'">
    <navbar
      :primary="checkoutFlow.step.value !== CheckoutFlowStep.CheckoutCompletePage ? true : false"
      class="px-4" />

    <div
      v-if="isWarehouseLoading"
      class="d-flex flex-column align-center justify-center gap-4 py-16 my-auto">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      <p class="juno-i18n-exclude text-body-1 text-grey">{{ t('checkoutFlow.loadingMessage') }}</p>
    </div>

    <component v-else :is="checkoutFlow.getCurrentStepComponent(checkoutFlow.step)" />

    <recaptcha-attribution v-if="isBffEnabled" class="mt-auto" />
  </div>
</template>
